/*
 *
 * SetPassword reducer
 *
 */

import { fromJS } from "immutable"
import {
  VALIDATE_USER_WATCHER,
  VALIDATE_USER_SUCCESS,
  VALIDATE_USER_FAILED,
  SET_PASSWORD_WATCHER,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED,
} from "./constants"

export const initialState = fromJS({
  validateCode: 0,
  isLoadingValidateCode: true,
  setPassCorrect: false,
  isLoadingSetPassCorrect: false,
})

function setPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PASSWORD_WATCHER:
      return state
        .set("setPassCorrect", false)
        .set("isLoadingSetPassCorrect", true)
    case SET_PASSWORD_SUCCESS:
      return state
        .set("setPassCorrect", true)
        .set("isLoadingSetPassCorrect", false)
    case SET_PASSWORD_FAILED:
      return state
        .set("setPassCorrect", false)
        .set("isLoadingSetPassCorrect", false)

    case VALIDATE_USER_WATCHER:
      return state.set("validateCode", 0).set("isLoadingValidateCode", true)
    case VALIDATE_USER_SUCCESS:
      return state
        .set("validateCode", action.payload)
        .set("isLoadingValidateCode", false)
    case VALIDATE_USER_FAILED:
      return state.set("validateCode", 404).set("isLoadingValidateCode", false)

    default:
      return state
  }
}

export default setPasswordReducer
